//apiServices.js

import axios from "axios";
import { API_BASE_URL } from "./config";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  // Add withCredentials for cookie handling if needed
  withCredentials: true,
  // Prevent axios from following redirects automatically
  maxRedirects: 0,
});

// Add auth token interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const googleToken = localStorage.getItem("googleToken");

    if (token) {
      // Ensure token is prefixed with 'Bearer'
      config.headers.Authorization = token.startsWith("Bearer ")
        ? token
        : `Bearer ${token}`;
    }

    if (googleToken) {
      // Ensure Google token is prefixed with 'Bearer'
      config.headers["Google-Token"] = googleToken.startsWith("Bearer ")
        ? googleToken
        : `Bearer ${googleToken}`;
    }

    // Don't override Content-Type if it's multipart/form-data
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }

    // console.log("Request config:", {
    //   url: config.url,
    //   method: config.method,
    //   headers: config.headers,
    //   data: config.data,
    // });

    return config;
  },
  (error) => {
    // console.error("Request interceptor error:", error);
    return Promise.reject(error);
  }
);

// Add response interceptor for better error handling
api.interceptors.response.use(
  (response) => {
    // console.log("Response:", {
    //   url: response.config.url,
    //   status: response.status,
    //   data: response.data,
    // });
    return response;
  },
  (error) => {
    // Handle redirect attempts
    if (error.response?.status === 307) {
      const originalRequest = error.config;
      if (!originalRequest._retry) {
        originalRequest._retry = true;
        // Follow the redirect manually
        return api(originalRequest);
      }
    }

    // Handle authentication errors
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      // Optionally redirect to login
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    // console.error("Response error:", {
    //   url: error.config?.url,
    //   status: error.response?.status,
    //   data: error.response?.data,
    // });
    return Promise.reject(error);
  }
);

export default api;
